import { useState } from "react";
import { Box } from "@mui/material";
import styles from "./style.module.css";
import { useSelector } from "react-redux";
import RoleShow from "./components/role-show";
import AddRoleModal from "./components/add-role-modal";
import AddNewRoleButton from "./components/add-new-role-button";

const RolesList = () => {
  const roles = useSelector((state) => state.roles.value);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleModal = async (state) => {
    setIsModalOpen?.(state);
  };

  const handleAddRole = () => {
    // const lastNum = roles[roles.length - 1]?.num || 0;
    // const newRole = {
    //   num: lastNum + 1,
    //   selectedCategory: '',
    //   selectedSkill: '',
    //   selectedSpecialty: '',
    // };
    // setRoles((prevRoles) => [...prevRoles, newRole]);
  };

  const renderRoles = roles.map((role, index) => {
    return <RoleShow role={role} key={role.num} num={index + 1} />;
  });

  return (
    <Box className={styles.roles}>
      <AddRoleModal isModalOpen={isModalOpen} handleModal={handleModal} />
      {renderRoles}
      <AddNewRoleButton
        handleModal={handleModal}
        handleAddRole={handleAddRole}
      />
    </Box>
  );
};

export default RolesList;
